// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btnBox[data-v-e8b13d7e] {\n  margin: 100px 0;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}", ""]);
// Exports
module.exports = exports;
